import React from "react"
import Button from "@/components/core/Button/Button"
import Modal from "@/components/core/Modal/Modal"
import { cartUpdatedModalAnalytics } from "@/components/checkout/CartUpdatedModal/analytics"
import { hideMergeModal } from "@/store/features/cartSlice"
import { useDispatch } from "react-redux"
const CartUpdatedModal = props => {
  const {
    isCheckoutModal = () => {},
    closeModal = () => {},
    staticTexts = {},
    isCartLandingPage,
  } = props
  const dispatch = useDispatch()
  const closeCartUpdatedModel = async () => {
    cartUpdatedModalAnalytics(false)
    dispatch(hideMergeModal())
  }

  const navigateToCartModel = () => {
    cartUpdatedModalAnalytics(true)
    const cartUrl = `${window.location.origin}/cart`
    window.location.href = cartUrl
  }

  return (
    <Modal
      showModal={isCheckoutModal}
      onModalClose={closeCartUpdatedModel}
      className="confirmation"
    >
      <div className="otp-popup__modal" aria-modal role="dialog" tabIndex="-1">
        <div className="otp-popup__small-case-title">
          {staticTexts.cartUpdatedMessage}
        </div>
        {!isCartLandingPage ? (
          <div className="otp-popup__buttonDiv">
            <Button
              className="otp-popup__button"
              type="black"
              role="button"
              label={staticTexts.viewCart}
              onClick={navigateToCartModel}
            />
            <Button
              className="otp-popup__button"
              type="ghost"
              role="button"
              label={staticTexts.stayHere}
              onClick={closeCartUpdatedModel}
            />
          </div>
        ) : (
          <div className="otp-popup__buttonDiv">
            <Button
              className="otp-popup__button"
              type="ghost"
              role="button"
              label={"OK"}
              onClick={closeCartUpdatedModel}
            />
          </div>
        )}
      </div>
    </Modal>
  )
}
export default CartUpdatedModal
